"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M5.19,9.21v1.31a8.57,8.57,0,0,1,8.5,8.82H15A9.86,9.86,0,0,0,5.19,9.21Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M5.19,3.91V5.2A14,14,0,0,1,19.33,19.34h1.29A15.26,15.26,0,0,0,5.19,3.91Z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#004864",
    cx: "7.15",
    cy: "17.38",
    r: "1.96"
  })));
};

exports["default"] = _default;